import { render, staticRenderFns } from "./SoundToggle.vue?vue&type=template&id=6e04d16c&"
import script from "./SoundToggle.vue?vue&type=script&lang=js&"
export * from "./SoundToggle.vue?vue&type=script&lang=js&"
import style0 from "./SoundToggle.vue?vue&type=style&index=0&id=6e04d16c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports